import React from 'react';

const PageHeader = ({ icon, title, subtitle, actions, compact = false, className = '' }) => (
  <div className={`bg-white/60 dark:bg-slate-800/60 backdrop-blur-md rounded-2xl shadow-sm border border-slate-200/50 dark:border-slate-700/60 flex flex-col md:flex-row justify-between items-start md:items-center transition-all ${compact ? 'p-3 sm:p-4 mb-4 gap-3' : 'p-5 sm:p-6 mb-6 gap-5'} ${className}`}>
    <div className="flex items-center gap-3 sm:gap-4">
      {icon && (
        <div className={`${compact ? 'w-9 h-9 rounded-lg' : 'w-12 h-12 rounded-xl'} bg-gradient-to-tr from-primary to-accent flex items-center justify-center text-white shadow-md shadow-primary/20 shrink-0`}>
          <i className={`fas ${icon} ${compact ? 'text-sm' : 'text-lg sm:text-xl'}`}></i>
        </div>
      )}
      <div>
        <h1 className={`${compact ? 'text-lg font-bold' : 'text-xl sm:text-2xl font-bold'} text-slate-800 dark:text-slate-100 flex items-center gap-2`}>
          {title}
        </h1>
        {subtitle && (
          <p className={`${compact ? 'text-[11px] mt-0.5' : 'text-xs mt-1'} text-slate-500 dark:text-slate-400`}>
            {subtitle}
          </p>
        )}
      </div>
    </div>
    {actions && (
      <div className={`flex items-center gap-3 flex-wrap w-full md:w-auto shrink-0 ${compact ? 'mt-1 md:mt-0' : 'mt-2 md:mt-0'}`}>
        {actions}
      </div>
    )}
  </div>
);

export default PageHeader;
